import { getTableIBM } from "../data.checker"
import { IBM_TABLES } from "./ibm/tables"
import { updateSellerByBuyerCode } from '@shared-logic/subjects/constants/seller-buyer-map';

export interface SellerObject {
  [key: string]: SellerIndividual
}

export interface SellerIndividual {
  sucProd: number,
  cgoProv: number,
  nombre: string,
  localidad: string,
  cuit: string,
  buyerCode?: number,
}

export let sellerWithData: SellerObject = getTableIBM(IBM_TABLES.CER002);

export let sellerByBuyerCode: { [buyerCode: string]: number } = {};

function buildSellerByBuyerCode(data: SellerObject): { [buyerCode: string]: number } {
  const map: { [buyerCode: string]: number } = {};
  for (const [sellerCode, seller] of Object.entries(data)) {
    if (seller.buyerCode != null) {
      map[String(seller.buyerCode)] = Number(sellerCode);
    }
  }
  return map;
}

sellerByBuyerCode = buildSellerByBuyerCode(sellerWithData);
updateSellerByBuyerCode(sellerWithData);

export function updateSellerWithData(data: SellerObject) {
  sellerWithData = data;
  sellerByBuyerCode = buildSellerByBuyerCode(data);
  updateSellerByBuyerCode(data);
}
